// Generated by BUCKLESCRIPT, PLEASE EDIT WITH CARE
'use strict';

var List = require("bs-platform/lib/js/list.js");
var $$Array = require("bs-platform/lib/js/array.js");
var Block = require("bs-platform/lib/js/block.js");
var Curry = require("bs-platform/lib/js/curry.js");
var React = require("react");
var Pervasives = require("bs-platform/lib/js/pervasives.js");
var Phoneme$Phonics = require("./Phoneme.bs.js");
var Storage$Phonics = require("./Storage.bs.js");
var SavedWords$Phonics = require("./SavedWords.bs.js");

var initialState_word = /* :: */[
  Phoneme$Phonics.a,
  /* [] */0
];

var initialState = {
  word: initialState_word,
  activeIndex: 0,
  display: /* DisplayPhonemeSelection */0
};

function str(prim) {
  return prim;
}

function selectPhoneme(index, phoneme, list) {
  return List.mapi((function (i, element) {
                if (i === index) {
                  return phoneme;
                } else {
                  return element;
                }
              }), list);
}

function reducer(state, action) {
  if (typeof action === "number") {
    switch (action) {
      case /* AddPhoneme */0 :
          return {
                  word: Pervasives.$at(state.word, /* :: */[
                        Phoneme$Phonics.a,
                        /* [] */0
                      ]),
                  activeIndex: List.length(state.word),
                  display: state.display
                };
      case /* RemovePhoneme */1 :
          if (List.length(state.word) > 1) {
            var newPhonemes = List.rev(List.tl(List.rev(state.word)));
            var length = List.length(newPhonemes);
            return {
                    word: newPhonemes,
                    activeIndex: List.length(newPhonemes) > state.activeIndex ? state.activeIndex : length - 1 | 0,
                    display: state.display
                  };
          } else {
            return state;
          }
      case /* LoadButtonClicked */2 :
          return {
                  word: state.word,
                  activeIndex: state.activeIndex,
                  display: /* DisplaySavedWords */1
                };
      case /* CloseSavedWordsClicked */3 :
          return {
                  word: state.word,
                  activeIndex: state.activeIndex,
                  display: /* DisplayPhonemeSelection */0
                };
      
    }
  } else {
    switch (action.tag | 0) {
      case /* PhonemeClicked */0 :
          return {
                  word: selectPhoneme(action[0], action[1], state.word),
                  activeIndex: state.activeIndex,
                  display: state.display
                };
      case /* SetActive */1 :
          return {
                  word: state.word,
                  activeIndex: action[0],
                  display: state.display
                };
      case /* SelectionClicked */2 :
          var clickedPhoneme = action[0];
          return {
                  word: List.mapi((function (index, phoneme) {
                          if (index === state.activeIndex) {
                            return clickedPhoneme;
                          } else {
                            return phoneme;
                          }
                        }), state.word),
                  activeIndex: state.activeIndex,
                  display: state.display
                };
      case /* LoadWord */3 :
          return {
                  word: action[0],
                  activeIndex: state.activeIndex,
                  display: state.display
                };
      
    }
  }
}

function Edit(Props) {
  var state = Props.state;
  var dispatch = Props.dispatch;
  var onViewButtonClicked = Props.onViewButtonClicked;
  var Edit$1 = function (Props) {
    var phoneme = Props.selectedPhoneme;
    var active = Props.active;
    var onClick = Props.onClick;
    return React.createElement("div", {
                className: "selected" + (
                  active ? " active" : ""
                )
              }, React.createElement(Phoneme$Phonics.make, {
                    phoneme: phoneme,
                    onClick: onClick
                  }));
  };
  var Edit$2 = function (Props) {
    return React.createElement("div", {
                className: "selection"
              }, $$Array.of_list(List.mapi((function (index, phoneme) {
                          return React.createElement(Phoneme$Phonics.make, {
                                      phoneme: phoneme,
                                      onClick: (function (param) {
                                          return Curry._1(dispatch, /* SelectionClicked */Block.__(2, [phoneme]));
                                        }),
                                      key: String(index)
                                    });
                        }), Phoneme$Phonics.phonemes)));
  };
  var Edit$3 = function (Props) {
    var word = Props.word;
    return React.createElement(React.Fragment, undefined, React.createElement("div", {
                    className: "word"
                  }, $$Array.of_list(List.mapi((function (index, selectedPhoneme) {
                              return React.createElement(Edit$1, {
                                          selectedPhoneme: selectedPhoneme,
                                          active: index === state.activeIndex,
                                          onClick: (function (param) {
                                              return Curry._1(dispatch, /* SetActive */Block.__(1, [index]));
                                            }),
                                          key: String(index)
                                        });
                            }), word)), React.createElement("button", {
                        className: "remove-phoneme",
                        onClick: (function (_evt) {
                            return Curry._1(dispatch, /* RemovePhoneme */1);
                          })
                      }, "-"), React.createElement("button", {
                        className: "add-phoneme",
                        onClick: (function (_evt) {
                            return Curry._1(dispatch, /* AddPhoneme */0);
                          })
                      }, "+")), React.createElement(Edit$2, { }));
  };
  var Edit$4 = function (Props) {
    return React.createElement("div", {
                className: "action"
              }, React.createElement("button", {
                    className: "transparent-button view-button",
                    title: "Play",
                    onClick: (function (_evt) {
                        return Curry._1(onViewButtonClicked, /* () */0);
                      })
                  }), React.createElement("button", {
                    className: "transparent-button save-button",
                    title: "Save",
                    onClick: (function (_evt) {
                        return Storage$Phonics.saveWord(state.word);
                      })
                  }), React.createElement("button", {
                    className: "transparent-button load-button",
                    title: "Load",
                    onClick: (function (_evt) {
                        return Curry._1(dispatch, /* LoadButtonClicked */2);
                      })
                  }));
  };
  var loadWord = function (word) {
    Curry._1(dispatch, /* LoadWord */Block.__(3, [word]));
    return Curry._1(dispatch, /* CloseSavedWordsClicked */3);
  };
  var match = state.display;
  return React.createElement("div", {
              className: "edit"
            }, match ? React.createElement(SavedWords$Phonics.make, {
                    onWordClicked: loadWord,
                    onCloseClicked: (function (param) {
                        return Curry._1(dispatch, /* CloseSavedWordsClicked */3);
                      })
                  }) : React.createElement(React.Fragment, undefined, React.createElement(Edit$3, {
                        word: state.word
                      }), React.createElement(Edit$4, { })));
}

var make = Edit;

exports.initialState = initialState;
exports.str = str;
exports.selectPhoneme = selectPhoneme;
exports.reducer = reducer;
exports.make = make;
/* react Not a pure module */
